import { IParticipant } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { ImageProgressComponent } from 'fwork.react.apptemplate/src/components/image'
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { uuidv7 } from 'uuidv7'
import axios from "../../apiClient/axios"
import { ParticipantsApiClient } from "../../apiClient/participants"
import { default as imageDefaultShield } from '../../assets/escudo.jpg'
import { IDotEnvProductionState } from "../../redux/reducers/dotenvProduction.slice"
import { RootState } from "../../redux/store"
import { EventsPopupComponent } from './eventPopup'

export const EventsParticipantComponent = (props: {
  participant: IParticipant,
  rounded?: boolean,
  defaultImg?: any,
}) => {
  const dotEnvProductionState: IDotEnvProductionState = useSelector((state: RootState) => state.dotEnvProductionState)
  const { enqueueSnackbar } = useSnackbar()

  const [uploadMenuAnchor, setUploadMenuAnchor] = React.useState<null | HTMLElement>(null)
  const [uploaddingImg, setUploaddingImg] = useState<boolean>(false)

  const imageUrl = `https://assets.aposte.bet/${props.participant.id}_b.png?v=${uuidv7()}`
  const [img, setImg] = useState<any>(imageUrl)


  const uploadImg = async (args: {
    fileSelected: File,
    url: string | undefined
  }) => {
    const fileSelected = args.fileSelected
    if (!fileSelected) return

    if (uploaddingImg) return

    setUploaddingImg(true)

    try {
      var formData: any = new FormData()

      Object.entries(props.participant).forEach(([key, value]) => formData.append(key, value))

      formData.append('image', fileSelected)

      const response = await new ParticipantsApiClient(axios).put({ data: formData })

      if (response.success) {
        enqueueSnackbar(ApiClientUtils.getErrorMessage('Upload realizado com sucesso'), { variant: 'success' })
        if (args.url)
          // setImgState({ url: args.url as string })
          setImg(args.url)
      }
      else
        enqueueSnackbar(ApiClientUtils.getErrorMessage(`Erro na operação: ${response.msg}`), { variant: 'error' })
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setUploaddingImg(false)
    }
  }

  const openUploadMenu = (event: any) => setUploadMenuAnchor(event.currentTarget)
  const closeUploadMenu = () => setUploadMenuAnchor(null)

  useEffect(() => {
    setImg(imageUrl)
  }, [props.participant.id])

  return <>
    <div aria-label="EventsParticipantComponent" style={{ display: 'flex', paddingBlock: 5, alignItems: 'center' }}>
      <div style={{ paddingRight: 10 }}>
        <ImageProgressComponent
          progressProps={{
            size: 30,
            progress: uploaddingImg,
            circularColorIndicator: '#FFFFFF'
          }}
          width={30}
          height={30}
          style={{ cursor: 'pointer', borderRadius: props.rounded ? '100%' : 0 }}
          src={img}
          onError={() => setImg(props.defaultImg ? props.defaultImg : imageDefaultShield)}
          onClick={(e) => {
            e.stopPropagation()
            openUploadMenu(e)
          }}
        />
      </div>
      <span style={{ marginLeft: '5px' }}>{props.participant.name}</span> -
      <span style={{ marginLeft: '5px' }}>{props.participant.id}</span>
    </div>
    <EventsPopupComponent
      onFileSelected={(file: File, url: string | undefined) => {
        closeUploadMenu()
        uploadImg({ fileSelected: file, url })
      }}
      onCloseMenu={closeUploadMenu}
      anchorEl={uploadMenuAnchor}
    />
  </>
}